<script lang="ts">
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';
    import {FOND_REPORT} from 'src/features/erp-sutor/sutor-fonds';
    import GridFieldValue from 'shared/ui-widgets/grid/GridFieldValue.svelte';
    import ReportFondDetail from '../components/ReportFondDetail.svelte';
    import ReportWorker from '../components/ReportWorker.svelte';
    import ReportMachine from '../components/ReportMachine.svelte';
    import ReportWorkerPowerKeySum from '../components/ReportWorkerPowerKeySum.svelte';

    export let record: RecordRow;

    const machineField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.machineFieldId);
    const workerField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.workerFieldId);
    const dateField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.dateFieldId);
    const reportedPersonStandardField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.reportedPersonStandardFieldId);
    const reportedPersonOvertimeField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.reportedPersonOvertimeFieldId);
    const reportedMachineField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.reportedMachineFieldId);
    const personUnitField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.personUnitFieldId);
    const machineUnitField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.machineUnitFieldId);
</script>

<ReportFondDetail {record} attendanceWorkerField={workerField} on:text-note-edit>
    <svelte:fragment slot="heading">
        <ReportWorker {workerField}/>
        <ReportMachine {machineField}/>
    </svelte:fragment>

    <svelte:fragment slot="details">
        <LabeledValue label="Vykázáno (člověk)">
            <GridFieldValue field={reportedPersonStandardField} unitField={personUnitField} chipSize="sm"/>
        </LabeledValue>

        <LabeledValue label="Vykázáno (stroj)">
            <GridFieldValue field={reportedMachineField} unitField={machineUnitField} chipSize="sm"/>
        </LabeledValue>

        <LabeledValue label="Přesčas (člověk)">
            <GridFieldValue field={reportedPersonOvertimeField} unitField={personUnitField} chipSize="sm"/>
        </LabeledValue>

        <LabeledValue label="Vykázáno v PwK (člověk)">
            <ReportWorkerPowerKeySum {workerField} {dateField}/>
        </LabeledValue>
    </svelte:fragment>
</ReportFondDetail>